import Cookies from "js-cookie";

const TokenKey = "MTP-Token";

export function getToken() {
  return Cookies.get(TokenKey);
}

export function setToken(token) {
  return Cookies.set(TokenKey, token, { SameSite: 'None', Secure:true });
}

export function removeToken() {
  return Cookies.remove(TokenKey);
}



// WEBPACK FOOTER //
// ./src/utils/auth.js